import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaConfirmDialog } from '../alerta-confirm';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-me-receitas',
  templateUrl: './me-receitas.component.html',
  styleUrls: ['./me-receitas.component.css']
})
export class MeReceitasComponent implements OnInit {
  hideCL: boolean = false;
  arrCategorias: any[] = [];
  arrReceitas: any[] = [];
  stepAC: any = -1;
  avoidP: boolean = true;
  hideCrown: boolean = false;
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) { }

  ngOnInit() {

    if(this.tmaService.hcWA && this.tmaService.hcSO == 'ios' && !this.tmaService.hcPremium || this.tmaService.hcWA && this.tmaService.hcSO == 'android' && !this.tmaService.hcPremium){
      this.avoidP = true;
    }
    else{
        this.avoidP = false;
    }

    if(this.tmaService.hcWA && this.tmaService.hcSO == 'ios' || this.tmaService.hcWA && this.tmaService.hcSO == 'android' ){
      this.hideCrown = true;
    }


    this.loadReceitas();
  }

  ngAfterViewInit(){
    console.log("after view");
    this.scrollToActive();
    // const itemToScrollTo = document.getElementById('dd_' + this.stepAC);
    // // null check to ensure that the element actually exists
    // if (itemToScrollTo) {
    //   console.log("should scroll");
    //   itemToScrollTo.scrollIntoView(true);
    // }
  }

  loadReceitas() :void{
    if(this.tmaService.acReceitaPos != -1){
      this.stepAC = this.tmaService.acReceitaPos;
    }

    let customParams = {
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha
    };
    this.tmaService.listarReceitas(customParams).subscribe((qRes) => {
      this.hideCL = true;
      console.log(qRes);
      if (qRes['res'] == 'done') {
        console.log(this.stepAC);
        this.arrCategorias = qRes['categorias'];
        this.arrReceitas = qRes['receitas'];
        //this.scrollToActive();
        setTimeout(() => {
          if(this.stepAC != -1){
            document.querySelector('#dd_' + this.stepAC).scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 500);
       
      }
      else {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Ocorreu um erro ao carregar as receitas", iconAlerta: 'warning' }
        })
      }
    },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        });
      })

  }
  setReceitaStep(qIndex : any) :void{

    this.tmaService.acReceitaPos = qIndex;
    console.log(qIndex);
    
  }

  resetReceitaStep() :void{
    //this.tmaService.acReceitaPos = -1;
  }

  scrollToActive() {
    //document.querySelector('#dd_' + this.stepAC).scrollIntoView();
    //document.getElementById('dd_' + this.stepAC).scrollIntoView();
  
 }
  goReceita(id: any, ispremium : boolean) :void{
    if(ispremium){
      //check if user premium
      if(this.tmaService.hcPremium){
        //ok liberado
        this.router.navigate(['/me/receita/' + id]);
      }
      else{
        const dialogRefConf = this.dialog.open(AlertaConfirmDialog, {
          width: '300px',
          data: { tituloAlerta: "Premium", textoAlerta: "Esta é uma receita exclusiva para usuários premium. Deseja saber mais sobre os benefícios?", textoCancel: "Não", textoConfirm: "SIM" }
        });
        dialogRefConf.afterClosed().subscribe(result => {
          if (result == true) {
            this.router.navigate(['/premium']);
          }
        });
      }
    }
    else{
      this.router.navigate(['/me/receita/' + id]);
    }
  }

  voltar() :void{
    //this._location.back();
    this.router.navigate(['home']);
  }

}
